import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.boundClose = this.close.bind(this);
    document.addEventListener("click", this.boundClose);
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose);
  }

  toggle(e) {
    e.preventDefault();
    e.stopPropagation();
    this.contentTarget.classList.toggle("invisible");
    this.contentTarget.classList.toggle("opacity-0");
  }

  close(e) {
    if (!this.element.contains(e.target)) {
      this.contentTarget.classList.add("invisible", "opacity-0");
    }
  }
}
